import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { IChangeRequestApprovers, ICommentInput, IUploadReceipt } from './interface';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class RequetService {
    http: HttpClient = inject(HttpClient);

    uploadReceipt(input: IUploadReceipt) {
        return this.http.post<IUploadReceipt>(`${API_URI}/upload-receipt`, input);
    }
    comment(input: ICommentInput) {
        return this.http.patch(`${API_URI}/update-approver-status`, input);
    }

    getApprovers() {
        return this.http.get<IChangeRequestApprovers[]>(`${API_URI}/change-request-approvers`);
    }
}
